import React from 'react';
import { Logo } from './Logo';
const columns = [{
  title: 'For you',
  links: ['AVEGA Play', 'AVEGA Events', 'Privacy center', 'FAQ']
}, {
  title: 'For business',
  links: ['AVEGA Studio', 'AVEGA Insights', 'Organizers', 'Creators']
}, {
  title: 'Trust',
  links: ['Privacy', 'Action rules', 'Terms', 'Contact']
}];
export function Footer() {
  return <footer className="overflow-hidden bg-forest-deep text-white" data-id="element-92" data-mp="36nd6rkymqg4q">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 pt-16 lg:grid-cols-12 lg:px-8" data-id="element-93" data-mp="3ugbrpazjbkkx">
        <div className="lg:col-span-5" data-id="element-94" data-mp="37o6qw57hzdw">
          <Logo tone="light" data-id="element-95" data-mp="36mr0ed8wopu" />
          <p className="mt-5 max-w-xs text-white/60" data-id="element-96" data-mp="3levhb38pzigp">People. Experiences. Value.</p>
        </div>
        <nav className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-7" aria-label="Footer" data-id="element-97" data-mp="3qd6u9muba935">
          {columns.map(col => <div key={col.title} data-id="element-98" data-mp="29ydxq3q81abh">
              <h2 className="text-sm font-semibold text-mint" data-id="element-99" data-mp="2a1jm1gr10865">{col.title}</h2>
              <ul className="mt-4 space-y-3" data-id="element-100" data-mp="2ezl3xycpu1g1">
                {col.links.map(link => <li key={link} data-id="element-101" data-mp="3la290texx1up">
                    <a href="#top" className="text-sm text-white/65 transition-colors duration-150 hover:text-white" data-id="element-102" data-mp="3gagyrmubl72o">
                      {link}
                    </a>
                  </li>)}
              </ul>
            </div>)}
        </nav>
      </div>
      <p aria-hidden="true" className="mt-12 select-none text-center font-display text-[22vw] font-extrabold leading-[0.8] tracking-[0.06em] text-white/[0.06]" data-id="element-103" data-mp="3qapz9cvchenv">
        AVEGA
      </p>
      <div className="border-t border-white/10" data-id="element-104" data-mp="3232hadx3j13">
        <div className="mx-auto flex max-w-7xl flex-col justify-between gap-2 px-5 py-6 text-xs text-white/50 sm:flex-row lg:px-8" data-id="element-105" data-mp="hrs5lb5klx40">
          <p data-id="element-106" data-mp="cuiii25nlxjc">© 2026 AVEGA</p>
          <p data-id="element-107" data-mp="qthzcnmxd84y">Grow together</p>
        </div>
      </div>
    </footer>;
}